import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

export default styled(Card)(({ theme }) => ({
  height: "100%",
  // Título de card na escala Mabry do sistema (600, -0.01em), não em 700.
  [`& .MuiCardHeader-root .MuiCardHeader-content .MuiCardHeader-title`]: {
    ...theme.typography.h4,
    color: theme.palette.text.primary,
  },
  [`& .MuiCardHeader-root .MuiCardHeader-avatar`]: {
    color: theme.palette.text.primary,
  },
}));
